import { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export const ActionPanelContainer = (
  props: { type?: string } & HTMLProps<HTMLDivElement>,
) => (
  <div
    {...props}
    className={twMerge(
      props.type === "default" && "bg-gray-100",
      props.type === "error" && "border-red-200 bg-red-100",
      "rounded-lg p-6",
      props.className,
    )}
  />
);
